
import { z } from "zod";

// Reusable schema for belt colors
export const beltColors = [
  { value: "White", label: "White Belt" },
  { value: "Blue", label: "Blue Belt" },
  { value: "Purple", label: "Purple Belt" },
  { value: "Brown", label: "Brown Belt" },
  { value: "Black", label: "Black Belt" }
];

// Macro curriculum schema
export const macroCurriculumSchema = z.object({
  title: z.string().min(1, "Title is required"),
  belt_color: z.string().min(1, "Belt color is required"),
  stripe_count: z.coerce.number().min(0).max(4),
  content: z.string().min(1, "Content is required"),
  image_url: z.string().url().optional().or(z.literal("")),
  video_url: z.string().url().optional().or(z.literal("")),
  order_index: z.coerce.number().int("Order must be an integer"),
  is_active: z.boolean().default(true),
});

export type MacroCurriculumFormValues = z.infer<typeof macroCurriculumSchema>;

// Meso curriculum schema with additional fields for key techniques and learning objectives
export const mesoCurriculumSchema = macroCurriculumSchema.extend({
  key_techniques: z.array(z.string()).default([]),
  learning_objectives: z.array(z.string()).default([]),
});

export type MesoCurriculumFormValues = z.infer<typeof mesoCurriculumSchema>;
